import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '10fr 6fr 8fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '9fr 4fr 3fr',
    color: theme.palette.text.secondary,
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    alignItems: 'center'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '10fr 6fr 8fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRowMobile: {
    display: 'grid',
    columnGap: 8,
    gridTemplateColumns: '9fr 4fr 3fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'initial',
    paddingLeft: 12,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  }
}))

export default useStyles
